import script from "./batch-background-remover.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-background-remover.vue?vue&type=script&setup=true&lang=js"

import "./batch-background-remover.vue?vue&type=style&index=0&id=7de5b1ab&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de5b1ab"]])

export default __exports__